import { render } from "./myIncome.vue?vue&type=template&id=24ad2e73&scoped=true"
import script from "./myIncome.vue?vue&type=script&lang=js"
export * from "./myIncome.vue?vue&type=script&lang=js"

import "./myIncome.vue?vue&type=style&index=0&id=24ad2e73&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24ad2e73"]])

export default __exports__